import { AssetSpec, SpriteAssetSpec } from "@westpierstudio/luma/factory/PixiFactory";
import { DefaultLayout } from "@westpierstudio/luma/layout";
import { View } from "@westpierstudio/luma/mvc";
import { Resettable } from "@westpierstudio/luma/utils/reset";
import { GameServices } from "game/GameServices";
import { AbstractRenderer, Renderer, Sprite, Texture } from "pixi.js";
import { OrientationSpec } from "servertypes/SharedTypes";

interface BackgroundSpec extends AssetSpec {
    position: OrientationSpec<AssetSpec>;
    baseGameBackground: SpriteAssetSpec;
    freeGameBackground: SpriteAssetSpec;
}

export class Background extends View implements Resettable {
    protected readonly backgroundSprite: Sprite;

    protected readonly baseGameTexture: Texture;
    protected readonly freeGameTexture: Texture;
    protected readonly spec: BackgroundSpec;

    constructor(protected override readonly services: GameServices, protected readonly layout: DefaultLayout) {
        super(services);

        const { factory, resources } = this.services;

        const spec = this.spec = resources.getSpec(`background`) as BackgroundSpec;

        this.backgroundSprite = factory.createSprite(spec.baseGameBackground, this);
        this.baseGameTexture = this.backgroundSprite.texture;
        this.freeGameTexture = resources.getTexture(spec.freeGameBackground._key);

        this.backgroundSprite.pivot = { x: this.backgroundSprite.width / 2, y: this.backgroundSprite.height / 2 };

        this.resize();
        this.reorient();
        layout.onResize.add(() => this.resize());
        layout.onReorient.add(() => this.reorient());
    }

    prepareFreeGameTransition() {
        this.services.application.renderer.plugins.prepare?.upload(this.freeGameTexture);
    }

    setBackgroundBaseGame() {
        this.backgroundSprite.texture = this.baseGameTexture;
    }

    setBackgroundFreeGame() {
        this.backgroundSprite.texture = this.freeGameTexture;
    }

    private reorient(): void {
        const { factory, layout } = this.services;
        factory.applySpec(this, this.spec.position[layout.orientation]);
    }

    private resize(): void {

        const bounds = this.services.layout.getScreenBoundaryInBucketSpace();
        if (bounds.width / this.width > bounds.height / this.height) {
            this.width = bounds.width;
            this.scale.y = this.scale.x;

        } else {
            this.height = bounds.height;
            this.scale.x = this.scale.y;
        }
        if (this.scale.x < 1) {
            this.scale.x = this.scale.y = 1;
        }
    }
}